import React from 'react';
import runningInDev from 'utils/runningInDev';

if (runningInDev) {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: false,
  });
}
